import type { FunctionComponent, T, ReactNode } from "react";

import React from "react";
export type tagVariant = "green" | "gray";

export interface TypeTag extends FunctionComponent<"a"> {
	variant?: tagVariant;
	index?: number;
	children: ReactNode | ReactNode[];
	as?: T | undefined;
	openLinkInNewTab?: boolean;
}

export const Tag = ({
	children,
	variant,
	index,
	as,
	openLinkInNewTab,
	...props
}: TypeTag) => {
	// Si se proporciona un índice, alternar entre green y gray
	const computedVariant = index !== undefined 
		? (index % 2 === 0 ? "green" : "gray")
		: (variant || "green");
	
	const VARIANT_MAP: Record<tagVariant, string> = {
		"green": "tag-green",
		"gray": "tag-gray"
	};
	const HTMLTag = as || "a";
	return (
		<HTMLTag
			{...(openLinkInNewTab && {
				target: "_blank",
				rel: "noreferrer noopener",

			})}
			{...props}
			className={`tag ${VARIANT_MAP[computedVariant]}`}
		>
			{children}
		</HTMLTag>
	);
};
